import './styles.css';
import { CubeEntryApp } from './app.js';

const appRoot = document.querySelector('#app');
new CubeEntryApp(appRoot);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(new URL('sw.js', document.baseURI).href)
      .then((registration) => registration.update())
      .catch(() => {
        // 离线能力不是启动页面的前置条件；注册失败时保持核心功能可用。
      });
  });
}
